import { Injectable } from '@angular/core';

import { OfficeRoute } from '../constants/office-route.enum';
import { FileItem, FileType } from '../models/file-item.model';
import { ConfigParserService } from './config-parser.service';
import { OfficeRouteItem } from './office-route.service';

interface TitlesConfig {
    defaultTitle: string;
    defaultIcon: string;
    appTitleConfigs: Array<AppTitleConfig>;
    galleryTitle: string;
}

interface AppTitleConfig {
    app: string;
    title: string;
    icon: string;
}

export interface TitleInfo {
    title: string;
    favicon: string;
}

@Injectable({
    providedIn: 'root'
})
export class OfficeTitleService {
    private readonly defaultTitle: string;
    private readonly defaultIcon: string;
    private readonly appTitleInfo: Map<FileType, AppTitleConfig>;
    private readonly galleryTitle: string;

    constructor(configParserService: ConfigParserService) {
        const config = configParserService.parse<TitlesConfig>('titlesConfig');
        this.appTitleInfo = new Map<FileType, AppTitleConfig>();
        if (!config || !config.appTitleConfigs) {
            return;
        }
        this.defaultTitle = config.defaultTitle;
        this.defaultIcon = config.defaultIcon;
        this.galleryTitle = config.galleryTitle;
        config.appTitleConfigs.forEach(c => {
            this.appTitleInfo.set(FileItem.fileTypeNameToFileType(c.app), c);
        });
    }

    public getTitle(route: OfficeRouteItem, documentTitle?: string): string {
        if (!route || !route.app || !this.appTitleInfo.has(route.app)) {
            return route.route === OfficeRoute.AppGallery ? this.galleryTitle : this.defaultTitle;
        }

        return documentTitle || this.appTitleInfo.get(route.app).title;
    }

    public getFavicon(route: OfficeRouteItem): string {
        if (!route || !route.app || !this.appTitleInfo.has(route.app)) {
            return this.defaultIcon;
        }

        return this.appTitleInfo.get(route.app).icon || this.defaultIcon;
    }
}
